import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import pgReducer from "./slices/pgSlice";
import countReducer from "./slices/countSlice";
import lawfirmReducer from "./slices/lawFirmSlice";
import teamMemberReducer from "./slices/teamMemberSlice";
import bondArchivesReducer from "./slices/bondArchivesSlice";
import pgBondsReducer from "./slices/pgBondsSlice";
import lawFirmBondsReducer from "./slices/lawFirmBondsSlice";
import premiumReducer from "./slices/premiumSlice";
// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["bondArchives", "pgBonds", "lawFirmBonds"],
};

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  pg: pgReducer,
  counter: countReducer,
  lawfirm: lawfirmReducer,
  teamMember: teamMemberReducer,
  bondArchives: bondArchivesReducer,
  pgBonds: pgBondsReducer,
  lawFirmBonds: lawFirmBondsReducer,
  premium: premiumReducer,
});

// Apply persistence to root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Redux store
const store = configureStore({
  reducer: persistedReducer,
});

// Persistor instance for <PersistGate>
const persistor = persistStore(store);

export { store, persistor };
